import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  IdpModalfocusDirectiveModule,
  ImageModule,
  SimpleModalModule
} from '@com-delta-idp/mnx-ui-kit';
import { PushModule } from '@ngrx/component';
import { PaginatorModule } from '../paginator/paginator.module';
import { WelcomeTourComponent } from './welcome-tour.component';

@NgModule({
  declarations: [WelcomeTourComponent],
  imports: [
    CommonModule,
    ImageModule,
    PaginatorModule,
    PushModule,
    IdpModalfocusDirectiveModule,
    SimpleModalModule
  ],
  exports: [WelcomeTourComponent]
})
export class WelcomeTourModule {}
